<template>
	<div :class="className">
		<div class="title">
			<h2>I TUOI CLIENTI</h2>
		</div>
		<div class="container md-elevation-4"></div>
	</div>
</template>

<script>
export default {
	name: "Clients",
	props: ["className"]
}
</script>

<style scoped>
.container {
	background-color: white;
	padding: 10px;
	margin-left: 10px;
}
</style>
